import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  margin: 0 0.5rem 0 0;

  --text-color: ${({ theme }) => theme.checkoutOnePage?.textColor};
`;
